import { IApplicationState } from '../../types/redux';

export function getJKid(state: IApplicationState) {
  const {
    newbuilding: { id },
  } = state;

  return id;
}
